import { gql } from '@apollo/client';

export const GET_PAID_SERVICES = gql`
  query paidServices($targetType: PaidServiceTargetTypeEnum!, $targetId: ID) {
    paidServices(targetType: $targetType, targetId: $targetId) {
      description
      id
      targetType
      title
      options {
        description
        discount
        id
        name
        price
      }
      paymentMethods {
        balance
        id
        name
      }
    }
  }
`;
